module.exports = __webpack_public_path__ + "images/skewness-16-desktop.png";